import React from 'react'

import { connect } from 'react-redux'
import { grey500 } from 'material-ui/styles/colors'

import ChatRoomAvatar from '../../chat/ChatRoomAvatar'
import PinHint from './PinHint'
import ClockUtils from '../common/ClockUtils'
import JobStatus from 'infra/JobStatus'

const PIN_BASE_SIZE = 25
const PIN_UPPER_LIMIT = 30
const PIN_ANIMATION_STEP = 0.02

class Pin extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      pinSize: PIN_BASE_SIZE,
      clockData: {},
      overrideColor: null,
      animate: false
    }
    this.animationDelta = PIN_UPPER_LIMIT - PIN_BASE_SIZE
    this.angle = 0
  }

  componentDidMount() {
    const clockData = ClockUtils.getClockData(this.props.eventInfo, this.props.dateStr)
    this.handleStatusView(clockData)
  }

  componentWillReceiveProps(nextProps){
    if (this.props.eventInfo !== nextProps.eventInfo
        || this.props.dateStr !== nextProps.dateStr) {
      const clockData = ClockUtils.getClockData(nextProps.eventInfo, nextProps.dateStr)
      this.handleStatusView(clockData)
    }
  }

  handleStatusView = (clockData) => {
    let overrideColor, animate
    switch (clockData.status) {
      case JobStatus.NOT_STARTED:
        overrideColor = grey500
        animate = false
        break
      case JobStatus.IN_PROGRESS:
        overrideColor = grey500
        animate = true
        break
      case JobStatus.COMPLETED:
        overrideColor = null
        animate = false
        break
    }
    this.setState({ clockData, overrideColor, animate })
  }

  modulatePinSize = () => {
    //TODO for bigger/smaller animation if needed
    const radians = Math.sin(this.angle)
    const deltaCoefficient = Math.abs(radians)
    const delta = deltaCoefficient * this.animationDelta
    const pinSize = PIN_BASE_SIZE + delta

    this.angle += PIN_ANIMATION_STEP
    this.setState({ pinSize, opacity: deltaCoefficient })
  }

  getWorkers() {
    const result = []
    const { eventInfo, teamMembers } = this.props
    const commonInfo = eventInfo.commonInfo && eventInfo.commonInfo.modules
    Object
      .values(commonInfo.workers.list)
      .forEach(worker => {
        const teamMember = teamMembers.find((member) => member.userId === worker.id)
        if (teamMember){
          result.push(teamMember)
        }
      })
    return result
  }

  render() {
    const members = this.getWorkers()
    const pinSize = this.props.hover ? PIN_UPPER_LIMIT : PIN_BASE_SIZE
    return (
      <div ref={el => this.anchorEl = el}>
        <ChatRoomAvatar
          style={{ alignSelf: 'center' }}
          size={pinSize}
          members={members}
          animate={this.state.clockData.status === JobStatus.IN_PROGRESS}
          overrideColor={this.state.overrideColor} />
        {
          this.props.hover &&
          <PinHint
            clockData={this.state.clockData}
            eventInfo={this.props.eventInfo}
            dateStr={this.props.dateStr} />
        }
      </div>
    )
  }
}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(Pin)



// WEBPACK FOOTER //
// ./src/schedule/map/Pin.js